import { Buffer } from 'buffer'

import process from 'process/browser'

// webpack's ProvidePlugin supplied these as globals; Vite ships no node shims.
// Buffer is used for base64 in src/api/auth-api.tsx and by the brotli-decoding
// report requests. process is read at module scope by the `path` browserify
// shim that `content-disposition` pulls in.
globalThis.Buffer ??= Buffer
globalThis.process ??= process
